import { ISerialisedPricedServiceCodeSummary } from './common';
import { ITreatmentStepEventFact } from './treatment-step-event';

export interface IAppointmentServiceCodeEvent extends ITreatmentStepEventFact {
  serviceCode: ISerialisedPricedServiceCodeSummary;
}
